import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Empty } from 'antd';

import BackupSummaryContext from '@totem/components/services/backup/deviceBackups/backupSummary/backupSummaryContext';
import DonutChart from '@totem/components/services/backup/deviceBackups/backupSummary/donutChart';
import { SummaryRecord } from '@totem/components/services/backup/deviceBackups/backupSummary/types';
import { getBackupAging } from '@totem/components/services/backup/deviceBackups/utilities';
import { isNotNull, isNull } from '@totem/utilities/common';

const BackupAgingChart = () => {
  const navigate = useNavigate();
  const { data } = useContext(BackupSummaryContext);
  const baseLink =
    '/dashboard/deviceBackups?page=1&pageSize=10&sortDirection=1&sortField=device.displayName';

  const getAgingColors = () => {
    if (isNotNull(data)) {
      return data.currency.map((point) => getBackupAging(point.name).color);
    }
    return [];
  };

  const handleStatusChartItemClicked = (point: SummaryRecord) => {
    switch (point.name) {
      case 'Stale':
        navigate(`${baseLink}&isBackupStale=true`);
        break;
      case 'Current':
        navigate(`${baseLink}&isBackupStale=false`);
        break;
      default:
        break;
    }
  };

  if (isNull(data)) {
    return <Empty />;
  }

  return (
    <div style={{ height: '100%', width: '100%', overflow: 'hidden' }}>
      <DonutChart
        chartData={data.currency}
        chartOptions={{ colors: getAgingColors() }}
        height="100%"
        onItemClicked={handleStatusChartItemClicked}
      />
    </div>
  );
};

export default BackupAgingChart;
